import React from 'react';
import Navbar from '../components/Navbar';

export default function Contact() {
  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Official Business Location ✦</span>
          <h1 className="section-title">Contact & Office Location</h1>
          <p style={{ color: '#6E615E', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Main Business Office Location: <strong>Yogikuti, Butwal, Nepal</strong>.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {/* Office 1: Matrimonial Office */}
          <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>💍</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Matrimonial Consultation Agency
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Vivah Nepal Matrimony
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Managing Director: Laxmikant Timilsina
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              📍 Location: Yogikuti, Butwal, Nepal.<br />
              📲 QR Payment & Direct Phone: <strong>9857074103</strong><br />
              💰 Registration Fee: NPR 1,000 (Includes 3 Curated Matches)
            </p>
            <a href="tel:9857074103" className="btn btn-primary btn-full">
              📞 Call Laxmikant: 9857074103 →
            </a>
          </div>

          {/* Office 2: Catering & Decor */}
          <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>🏢</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Catering & Tent House Services
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Sabitri Catering & Tent House
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Managing Director: Krishna Khanal
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              📍 Location: Yogikuti, Butwal, Nepal.<br />
              📞 Direct Phone: <strong>9867155395</strong><br />
              🍱 Banquets, Palpali Bhoj, Marquee Tents & Mandap Decor
            </p>
            <a href="tel:9867155395" className="btn btn-secondary btn-full">
              📞 Call Krishna: 9867155395 →
            </a>
          </div>

          {/* Office 3: Technical Support */}
          <div className="card" style={{ border: '1.5px solid #E8DFD1' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>💻</div>
            <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23', marginBottom: '0.6rem' }}>
              Lead Technical Support
            </span>
            <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
              Prakash Sharma Timilsina
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.8rem' }}>
              Chief Technical Advisory & System Architect
            </div>
            <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              Leads Django Python backend, React frontend infrastructure, GCP cloud server hosting, and digital platform security.
            </p>
            <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-full">
              Visit Digital Portfolio: pourkas.org →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
